import { RepairOrderQuoteModel } from 'api-new/generated';
import { create } from 'zustand';

type InitState = {
  soHeaderId?: number;
  branch?: number;
};

type RepairOrderQuotesState = {
  isEditMode: boolean;
  initState?: InitState;
  setInitState: (state?: InitState) => void;
  setIsEditMode: (isEditMode: boolean) => void;
  increaseLoading: () => void;
  decreaseLoading: () => void;
  loadingCount: number;
  dataState?: RepairOrderQuoteModel[];
  setDataState: (state: RepairOrderQuoteModel[]) => void;
};

export const useRepairOrderQuotesStore = create<RepairOrderQuotesState>((set) => ({
  isEditMode: false,
  isLoading: false,
  loadingCount: 0,
  dataState: undefined,
  initState: undefined,
  setInitState: (state?: InitState) => set({ initState: { ...(state ?? {}) } }),
  setIsEditMode: (isEditMode: boolean) => set({ isEditMode: isEditMode }),
  increaseLoading: () => set((state) => ({ loadingCount: ++state.loadingCount })),
  decreaseLoading: () => set((state) => ({ loadingCount: state.loadingCount <= 0 ? 0 : --state.loadingCount })),
  setDataState: (state: RepairOrderQuoteModel[]) => set({ dataState: state })
}));
